import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateGamePartnerDelete = {
  gamePartnerDelete: { data: null, loading: false, error: null },
};

export const gamePartnerDelete = createAsyncThunk('user/gamePartnerDelete', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .post(`/game/partner/delete`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGamePartnerDelete = {
  [gamePartnerDelete.pending]: (state) => {
    state.gamePartnerDelete.loading = true;
  },
  [gamePartnerDelete.fulfilled]: (state, action) => {
    state.gamePartnerDelete.loading = false;
    state.gamePartnerDelete.data = action.payload;
    state.gamePartnerDelete.error = null;
  },
  [gamePartnerDelete.rejected]: (state, action) => {
    state.gamePartnerDelete.loading = false;
    state.gamePartnerDelete.error = action.payload;
  },
};
